import React, { useState, useRef, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { displayDateTime } from 'reducers/TimeReducer';
import { connect, useDispatch } from 'react-redux';

import { showZoneSop, closeZoneSop, editSop, addSop, showReport } from 'reducers/DialogsReducer';
import { savePeopleSOP, deletePeopleSOP } from 'reducers/PersonReducer';
import { showSpinner, hideSpinner } from 'reducers/UiReducer';
import { handleError } from 'reducers/ErrorReducer';
import XGrid3 from 'components/XGrid3';
import { getZoneSops } from 'reducers/SearchReducer';
import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import Dialog from 'components/Dialog';
import Tooltip from 'components/Tooltip';
import Fab from '@material-ui/core/Fab';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import SOPFilter from '../Address/SOPFilter';
import { getFullPermissions } from 'reducers/PermissionsReducer';
import EditIcon from '@material-ui/icons/Edit';
import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles((theme) => ({
  wrap: {
    padding: theme.spacing(3),
  },
  gridWrap: {
    width: '100%',
    boxSizing: 'border-box',
    height: 600,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2),
    '& button': {
      marginLeft: theme.spacing(1),
    },
  },
  fileInput: {
    display: 'none',
  },
}));

const defaultColumns = [
  {
    field: 'SOPID',
    headerName: 'Title',
    valueGetter: (params) => params.row.SOP.SOPID,
    width: 200,
    hide: false,
  },
  {
    field: 'DispatcherMessage',
    headerName: 'Dispatcher Message',
    valueGetter: (params) => params.row.SOP.DispatcherMessage,
    width: 150,
    hide: false,
  },
  {
    field: 'AlertMessage',
    headerName: 'Alert Message',
    valueGetter: (params) => params.row.SOP.AlertMessage,
    width: 150,
    hide: false,
  },
  {
    field: 'IsPagingMessageUsed',
    headerName: 'Is paging used',
    valueGetter: (params) => params.row.SOP.IsPagingMessageUsed,
    width: 150,
    hide: false,
  },
  {
    field: 'ShowPopupNotification',
    headerName: 'Popup Notification',
    valueGetter: (params) => params.row.SOP.ShowPopupNotification,
    width: 150,
    hide: false,
  },
  {
    field: 'Created',
    headerName: 'Created',
    width: 120,
    valueFormatter: (params) => displayDateTime(params.value),
    format: 'date',
    hide: false,
  },
  { field: 'CreatedBy', headerName: 'Created By', width: 150, hide: false },
  {
    field: 'Updated',
    headerName: 'Updated',
    width: 120,
    valueFormatter: (params) => displayDateTime(params.value),
    format: 'date',
    hide: false,
  },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 150, hide: false },
  { field: 'IsDeleted', headerName: 'Is Deleted', width: 150, hide: false },
  {
    field: 'Deleted',
    headerName: 'Deleted',
    width: 120,
    valueFormatter: (params) => displayDateTime(params.value),
    format: 'date',
    hide: false,
  },
  { field: 'DeletedBy', headerName: 'Deleted By', width: 150, hide: false },
  { field: 'DeletedIP', headerName: 'Deleted IP', width: 150, hide: false },
];

const Sops = (props) => {
  const classes = useStyles();
  const { IntCode, zoneSop } = props;
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [selection, setSelection] = useState(null);
  const [columns, setColumns] = useState(defaultColumns);
  const dispatch = useDispatch();
  const mountedRef = useRef(true);
  const [selectedSOP, setSelectedSOP] = useState(null);
  const perms = getFullPermissions('globals', 'Zones', 'any');
  const canEditPerson = perms.Edit;

  useEffect(() => {
    IntCode && getData();
  }, []);

  useEffect(() => {
    if (props.dataUpdate && props.dataUpdate.type === 'update-sop') getData();
  }, [props.dataUpdate]);

  const getData = async () => {
    try {
      const data = await getZoneSops(IntCode);
      if (!mountedRef.current) return;

      setRows(processData(data.data));
      setLoaded(true);
    } catch (err) {
      props.handleError(err, 'Error receiving zones sops data.');
    }
  };

  const processData = (data) => {
    return data.map((row, idx) => {
      return {
        ...row,
        id: row.ptsSOPID,
      };
    });
  };

  const add = () => {
    props.addSop({ IntCode });
  };

  const close = () => {
    //dispatch(closePeopleSOP());
    props.closeZoneSop();
  };

  const save = async () => {
    dispatch(showSpinner());
    await savePeopleSOP({
      ptsParentID: IntCode,
      ParentType: 'Zone',
      ptsSOPID: selectedSOP,
    })
      .then((data) => {
        close();
        getData();
        dispatch(hideSpinner());
      })
      .catch((err) => {
        props.handleError(err);
        close();
        getData();
        dispatch(hideSpinner());
      });
  };
  const viewDetails = () => {
    let item = rows.find((row) => row.id === selection);
    if (!item) return;
    props.showReport({ id: 48, data: { ptsSOPID: item.ptsSOPID }, title: 'SOP Details' });
  };

  const editSop = () => {
    props.editSop(selection);
  };

  const deleteSOP = async () => {
    if (!window.confirm('Are you sure you want to delete this record?')) return;
    const item = rows.find((row) => row.id === selection);

    const updatedData = rows.filter((row) => row.id !== selection);
    setRows(updatedData);

    if (item) {
      dispatch(showSpinner());
      await deletePeopleSOP({
        ptsParentID: IntCode,
        ParentType: 'Zone',
        ptsSOPID: item.ptsSOPID,
      })
        .then(() => {
          getData();
          dispatch(hideSpinner());
        })
        .catch((err) => {
          console.log(err);
          getData();
          dispatch(hideSpinner());
        });
    }
  };

  const formContent = () => {
    return <SOPFilter selectSOP={setSelectedSOP} />;
  };

  const renderActions = () => {
    return (
      <>
        <Button
          color="primary"
          variant="contained"
          autoFocus
          onClick={save}
          disabled={!canEditPerson}>
          <SaveIcon /> Save
        </Button>
        <Button color="primary" onClick={close}>
          <CloseIcon /> Close
        </Button>
      </>
    );
  };

  return (
    <div className={classes.wrap}>
      <div className={classes.filterWrap}>
        <div className={classes.filterWrap}>
          {formContent()}
          <Button variant="outlined" autoFocus onClick={save} disabled={!canEditPerson}>
            Save
          </Button>
        </div>
        <div className={classes.actions}>
          <Tooltip title="Add SOP">
            <span>
              <Fab size="small" color="secondary" onClick={add} disabled={!canEditPerson}>
                <AddIcon />
              </Fab>
            </span>
          </Tooltip>

          {selection !== null && (
            <>
              <Tooltip title="Edit SOP">
                <Fab className="ml-2" size="small" color="secondary" onClick={editSop}>
                  <EditIcon />
                </Fab>
              </Tooltip>
              <Tooltip title="View details">
                <Fab className="ml-2" size="small" color="secondary" onClick={viewDetails}>
                  <InfoIcon />
                </Fab>
              </Tooltip>
              <Tooltip title="Delete SOP">
                <span>
                  <Fab size="small" color="secondary" onClick={deleteSOP} disabled={!canEditPerson}>
                    <DeleteIcon />
                  </Fab>
                </span>
              </Tooltip>
            </>
          )}
        </div>
      </div>

      {zoneSop && (
        <Dialog toolbar onClose={close} title="Add SOP" actions={renderActions()}>
          {formContent()}
        </Dialog>
      )}

      <XGrid3
        name="zoneSops"
        columns={columns}
        setColumns={setColumns}
        rows={rows}
        loading={!loaded}
        setSelection={setSelection}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    zoneSop: state.dialogs.zoneSop,
    dataUpdate: state.dataUpdate,
  };
};
export default connect(mapStateToProps, {
  addSop,
  editSop,
  showReport,
  handleError,
  showSpinner,
  hideSpinner,
  showZoneSop,
  closeZoneSop,
})(Sops);
